export default __webpack_public_path__ + "static/media/mobile_report-partner.0ebfc00a.png";